export default __webpack_public_path__ + "0dd0643426c031185bd3c4d5a33eeec4.svg";